import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelperService } from './helper.service';
import { FilterRequireAttachmentPipe } from './filter-require-attachment.pipe';
import { AddressComponent } from './components/address/address.component';
import { FuseSharedModule } from '../../@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '../../@fuse/components';
import { AttachmentComponent } from './attachment/attachment.component';
import { FileUploadModule } from 'ng2-file-upload';
import { BoxUserDetailComponent } from './components/box-user-detail/box-user-detail.component';
import { BoxUserCheckCreditDetailComponent } from './components/box-user-check-credit-detail/box-user-check-credit-detail.component';
import { BoxUserCheckBlacklistDetailComponent } from './components/box-user-check-blacklist-detail/box-user-check-blacklist-detail.component';
import { BaseBoxUserComponent } from './components/base-box-user/base-box-user.component';
import { DocumentStatusPipe } from './pipe/document-status.pipe';
import { ModalDrawerComponent } from './components/modal-drawer/modal-drawer.component';
import { ModalViewAttachmentComponent } from './components/modal-view-attachment/modal-view-attachment.component';
import { FromLinkDirective } from './directive/from-link.directive';


import { BlockNonNumberDirective } from './directive/block-non-number.directive';
import { ModalEditCommissionComponent } from 'app/main/commissions/shared/modal-edit-commission/modal-edit-commission.component';
import { DropdownCompanyComponent } from './components/dropdown-company/dropdown-company.component';
import { DropdownUserGroupComponent } from './components/dropdown-user-group/dropdown-user-group.component';
import { DropdownUserRoleComponent } from './components/dropdown-user-role/dropdown-user-role.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './components/confirmation-dialog/confirmation-dialog.service';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownSalesStructureComponent } from './components/dropdown-sales-structure/dropdown-sales-structure.component';
import { DropdownBranchComponent } from './components/dropdown-branch/dropdown-branch.component';
import { TreeComponent } from './components/tree/tree.component';
import { ModalSalesPersonComponent } from './components/modal-sales-person/modal-sales-person.component';
import { FormAddressComponent } from './components/form-address/form-address.component';
import { FileAttachmentComponent } from './components/file-attachment/file-attachment.component';
import { ModalTeamTransferComponent } from './components/modal-team-transfer/modal-team-transfer.component';
import { DropdownOfficeComponent } from './components/dropdown-office/dropdown-office.component';
import { ImageViewerModule } from 'ngx-image-viewer';
import { BoxSalesLogComponent } from './components/box-sales-log/box-sales-log.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';

import { CustomerInformationComponent } from './components/customer-information/customer-information.component';
import { AutocompleteBranchComponent } from './components/autocomplete-branch/autocomplete-branch.component';
import { FilterCompanyComponent } from './components/filter-company/filter-company.component';
import { PhonenumberDirective } from './directive/phonenumber.directive';
import { CurrencyformatterDirective } from './directive/currencyformatter.directive';
import { DecimalPipe } from '@angular/common';
import { AutocompleteProductGroupComponent } from './components/autocomplete-product-group/autocomplete-product-group.component';
import { AutocompleteProductComponent } from './components/autocomplete-product/autocomplete-product.component';
import { AutocompleteSegmentComponent } from './components/autocomplete-segment/autocomplete-segment.component';
import { IsabuySaleStructureComponent } from './components/isabuy-sale-structure/isabuy-sale-structure.component';
import { MaterialModule } from './modules/material.module';
import { CheckboxGroupComponent } from './components/checkbox-group/checkbox-group.component';
import { SumValuePipe } from './pipe/sum-value.pipe';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { CommissionStatusPipe } from './pipe/commission-status.pipe';
import { SaleStructureTreeComponent } from './components/sale-structure-tree/sale-structure-tree.component';
import { AutoTrimSpaceDirective } from './directive/auto-trim-space.directive';
import { LatitudeLongitudeFormatValidatorDirective } from './directive/lat-lng-format.directive';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
import { AdvanceFilterComponent } from './components/advance-filter/advance-filter.component';
import { DropdownMultipleSelectComponent } from './components/dropdown-multiple-select/dropdown-multiple-select.component';
import { MappingPipePipe } from './components/dropdown-multiple-select/mapping-pipe.pipe';

@NgModule({
    declarations: [
        FilterRequireAttachmentPipe,
        AddressComponent,
        AttachmentComponent,
        BoxUserDetailComponent,
        BoxUserCheckCreditDetailComponent,
        BoxUserCheckBlacklistDetailComponent,
        BaseBoxUserComponent,
        DocumentStatusPipe,
        ModalDrawerComponent,
        ModalViewAttachmentComponent,
        FromLinkDirective,
        ConfirmationDialogComponent,
        ModalEditCommissionComponent,
        BlockNonNumberDirective,
        DropdownCompanyComponent,
        DropdownUserGroupComponent,
        DropdownUserRoleComponent,
        DropdownSalesStructureComponent,
        DropdownBranchComponent,
        TreeComponent,
        ModalSalesPersonComponent,
        FormAddressComponent,
        FileAttachmentComponent,
        ModalTeamTransferComponent,
        DropdownOfficeComponent,
        BoxSalesLogComponent,
        FileUploadComponent,
        DynamicFormComponent,
        CustomerInformationComponent,
        AutocompleteBranchComponent,
        FilterCompanyComponent,
        PhonenumberDirective,
        CurrencyformatterDirective,
        AutocompleteProductGroupComponent,
        AutocompleteProductComponent,
        AutocompleteSegmentComponent,
        IsabuySaleStructureComponent,
        CheckboxGroupComponent,
        SumValuePipe,
        SkeletonLoaderComponent,
        CommissionStatusPipe,
        SaleStructureTreeComponent,
        AutoTrimSpaceDirective,
        LatitudeLongitudeFormatValidatorDirective,
        LoadingDialogComponent,
        AdvanceFilterComponent,
        DropdownMultipleSelectComponent,
        MappingPipePipe,
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseWidgetModule,
        FuseSidebarModule,
        FileUploadModule,
        NgbModule,
        ImageViewerModule,
        MaterialModule,
    ],
    exports: [
        FuseSharedModule,
        FuseWidgetModule,
        FuseSidebarModule,
        FilterRequireAttachmentPipe,
        AddressComponent,
        AttachmentComponent,
        FileUploadModule,
        BoxUserDetailComponent,
        BoxUserCheckCreditDetailComponent,
        BoxUserCheckBlacklistDetailComponent,
        DocumentStatusPipe,
        ModalDrawerComponent,
        ModalViewAttachmentComponent,
        FromLinkDirective,
        BlockNonNumberDirective,
        DropdownCompanyComponent,
        DropdownUserGroupComponent,
        DropdownUserRoleComponent,
        DropdownSalesStructureComponent,
        DropdownBranchComponent,
        TreeComponent,
        FormAddressComponent,
        FileAttachmentComponent,
        ModalTeamTransferComponent,
        ImageViewerModule,
        BoxSalesLogComponent,
        FileUploadComponent,
        DynamicFormComponent,
        CustomerInformationComponent,
        AutocompleteBranchComponent,
        FilterCompanyComponent,
        PhonenumberDirective,
        CurrencyformatterDirective,
        AutocompleteProductGroupComponent,
        AutocompleteProductComponent,
        AutocompleteSegmentComponent,
        IsabuySaleStructureComponent,
        CheckboxGroupComponent,
        SumValuePipe,
        SkeletonLoaderComponent,
        CommissionStatusPipe,
        SaleStructureTreeComponent,
        AutoTrimSpaceDirective,
        LatitudeLongitudeFormatValidatorDirective,
        AdvanceFilterComponent,
        DropdownMultipleSelectComponent,
    ],
    providers: [
        HelperService,
        ConfirmationDialogService,
        DecimalPipe
    ]
})
export class SharedModule {
}
